import { useEffect, useState } from 'react';

const useKeyPressToggle = (keyValue: KeyboardEvent['key']) => {
  const [isKeyDown, setIsKeyDown] = useState(false);

  useEffect(() => {
    const onKeydown = (e: KeyboardEvent) => {
      setIsKeyDown(() => {
        switch (e.key) {
          case 'Shift':
            return !e.altKey && !e.ctrlKey && !e.metaKey;
          case 'Alt':
            return !e.ctrlKey && !e.metaKey && !e.shiftKey;
          case 'Control':
            return !e.altKey && !e.metaKey && !e.shiftKey;
          default:
            return e.key === keyValue && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey;
        }
      });
    };

    const onKeyup = (e: KeyboardEvent) => {
      if (e.key === keyValue) setIsKeyDown(false);
    };

    document.addEventListener('keydown', onKeydown);
    document.addEventListener('keyup', onKeyup);

    return () => {
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('keyup', onKeyup);
    };
  }, [keyValue]);

  return isKeyDown;
};

export default useKeyPressToggle;
